module.exports = __webpack_public_path__ + "static/media/time-to-care-this-week-next-week.2c40593c.svg";